import React, { Component } from 'react';

import $dataRepo from 'dataRepository';

import './LicensesPage.css';

class LicensesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      licenses: null
    };
  }

  componentDidMount() {
    // load html
    $dataRepo.fetchLicensesData().then(json => this.setState({
      licenses: json
    }));
  }

  render() {
    const { licenses } = this.state;
    if (!licenses) {
      return null;
    }
    return (
      <div className="licenses-content-block header-border">
        <table>
          <thead>
            <tr>
              <th>
                Library
              </th>
              <th>
                License
              </th>
            </tr>
          </thead>
          <tbody>
            {
              licenses.map(license => (
                <tr key={license.library}>
                  <td>
                    {license.library}
                  </td>
                  <td>
                    {license.link}
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>
    );
  }
}

export default LicensesPage;
